import {
  BUSINESS_UNIT_ACTIVE,
  BUSINESS_UNIT_ACTIVE_FAIL,
  BUSINESS_UNIT_ACTIVE_RESET,
  BUSINESS_UNIT_ACTIVE_SUCCESS,
  BUSINESS_UNIT_CREATE,
  BUSINESS_UNIT_CREATE_FAIL,
  BUSINESS_UNIT_CREATE_RESET,
  BUSINESS_UNIT_CREATE_SUCCESS,
  BUSINESS_UNIT_DELETE,
  BUSINESS_UNIT_DELETE_FAIL,
  BUSINESS_UNIT_DELETE_RESET,
  BUSINESS_UNIT_DELETE_SUCCESS,
  BUSINESS_UNIT_DETAIL,
  BUSINESS_UNIT_DETAIL_FAIL,
  BUSINESS_UNIT_DETAIL_RESET,
  BUSINESS_UNIT_DETAIL_SUCCESS,
  BUSINESS_UNIT_LIST,
  BUSINESS_UNIT_LIST_COLUMN,
  BUSINESS_UNIT_LIST_FAIL,
  BUSINESS_UNIT_LIST_RESET,
  BUSINESS_UNIT_LIST_SUCCESS,
  BUSINESS_UNIT_ROLE_LIST,
  BUSINESS_UNIT_ROLE_LIST_FAIL,
  BUSINESS_UNIT_ROLE_LIST_RESET,
  BUSINESS_UNIT_ROLE_LIST_SUCCESS,
  BUSINESS_UNIT_UPDATE,
  BUSINESS_UNIT_UPDATE_FAIL,
  BUSINESS_UNIT_UPDATE_RESET,
  BUSINESS_UNIT_UPDATE_SUCCESS,
} from "./actionTypes";

// List BusinessUnit
export const listBusinessUnit = (params = {}) => ({
  type: BUSINESS_UNIT_LIST,
  payload: { params },
});

export const listBusinessUnitSuccess = data => ({
  type: BUSINESS_UNIT_LIST_SUCCESS,
  payload: data,
});

export const listBusinessUnitFail = error => ({
  type: BUSINESS_UNIT_LIST_FAIL,
  payload: error,
});

export const resetListBusinessUnit = () => ({
  type: BUSINESS_UNIT_LIST_RESET,
  payload: {},
});

export const setListBusinessUnitColumn = (field, value) => ({
  type: BUSINESS_UNIT_LIST_COLUMN,
  payload: { field, value },
});

// List BusinessUnit Role
export const listBusinessUnitRole = (params = {}) => ({
  type: BUSINESS_UNIT_ROLE_LIST,
  payload: { params },
});

export const listBusinessUnitRoleSuccess = data => ({
  type: BUSINESS_UNIT_ROLE_LIST_SUCCESS,
  payload: data,
});

export const listBusinessUnitRoleFail = error => ({
  type: BUSINESS_UNIT_ROLE_LIST_FAIL,
  payload: error,
});

export const resetListBusinessUnitRole = () => ({
  type: BUSINESS_UNIT_ROLE_LIST_RESET,
  payload: {},
});

// Create BusinessUnit
export const createBusinessUnit = userCreate => ({
  type: BUSINESS_UNIT_CREATE,
  payload: { userCreate },
});

export const createBusinessUnitSuccess = data => ({
  type: BUSINESS_UNIT_CREATE_SUCCESS,
  payload: data,
});

export const createBusinessUnitFail = error => ({
  type: BUSINESS_UNIT_CREATE_FAIL,
  payload: error,
});

export const resetCreateBusinessUnit = () => ({
  type: BUSINESS_UNIT_CREATE_RESET,
  payload: {},
});

// Detail BusinessUnit
export const detailBusinessUnit = (userId, params = {}) => ({
  type: BUSINESS_UNIT_DETAIL,
  payload: { userId, params },
});

export const detailBusinessUnitSuccess = data => ({
  type: BUSINESS_UNIT_DETAIL_SUCCESS,
  payload: data,
});

export const detailBusinessUnitFail = error => ({
  type: BUSINESS_UNIT_DETAIL_FAIL,
  payload: error,
});

export const resetDetailBusinessUnit = () => ({
  type: BUSINESS_UNIT_DETAIL_RESET,
  payload: {},
});

// Update BusinessUnit
export const updateBusinessUnit = (userId, data = {}) => ({
  type: BUSINESS_UNIT_UPDATE,
  payload: { userId, data },
});

export const updateBusinessUnitSuccess = data => ({
  type: BUSINESS_UNIT_UPDATE_SUCCESS,
  payload: data,
});

export const updateBusinessUnitFail = error => ({
  type: BUSINESS_UNIT_UPDATE_FAIL,
  payload: error,
});

export const resetUpdateBusinessUnit = () => ({
  type: BUSINESS_UNIT_UPDATE_RESET,
  payload: {},
});

// Delete BusinessUnit
export const deleteBusinessUnit = userId => ({
  type: BUSINESS_UNIT_DELETE,
  payload: { userId },
});

export const deleteBusinessUnitSuccess = data => ({
  type: BUSINESS_UNIT_DELETE_SUCCESS,
  payload: data,
});

export const deleteBusinessUnitFail = error => ({
  type: BUSINESS_UNIT_DELETE_FAIL,
  payload: error,
});

export const resetDeleteBusinessUnit = () => ({
  type: BUSINESS_UNIT_DELETE_RESET,
  payload: {},
});

// Active BusinessUnit
export const activeBusinessUnit = (userId, data = {}) => ({
  type: BUSINESS_UNIT_ACTIVE,
  payload: { userId, data },
});

export const activeBusinessUnitSuccess = data => ({
  type: BUSINESS_UNIT_ACTIVE_SUCCESS,
  payload: data,
});

export const activeBusinessUnitFail = error => ({
  type: BUSINESS_UNIT_ACTIVE_FAIL,
  payload: error,
});

export const resetActiveBusinessUnit = () => ({
  type: BUSINESS_UNIT_ACTIVE_RESET,
  payload: {},
});
